<template>
  <div class="page-flipper" v-if="!hidden" v-bind:class="{'is-animating': isAnimating}">
    <div v-on:click="prev()" class="nav left">
      <div class="mobile">
        <img src="../../assets/left.svg" alt="">
      </div>
    </div>
    <div v-on:click="next()" class="nav right">
      <div class="mobile">
        <img src="../../assets/right.svg" alt="">
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'PageFlipper',
    data () {
      return {
      }
    },
    methods: {
      prev () {
        this.$parent.$emit('prev');
      },
      next () {
        this.$parent.$emit('next');
      }
    },
    props: {
      isAnimating: Boolean,
      hidden: Boolean
    },
    computed: {
    },
    watch: {
      'isAnimating': function(v) {
        if(v) {

        }
      }
    }

  };
</script>
<style lang="scss">
  @import "../global.scss";
  .page-flipper {
    &.is-animating .nav {
      z-index: 100;
      // opacity: 0.7;
      // transition: opacity 0.1s ease;
      @media #{$mini-down} {
        display: none;
      }
    }
    .nav {
      // opacity:0.2;
      // background-color: #f00;
      // border:1px solid #f00;

      // pointer-events: auto;
      position:fixed;
      top:4rem;
      text-align: center;

      height:calc(100vh - 4rem);
      .mobile {

        display: none;
      }

      @media #{$mini-down} {
        position:absolute;

        height:5rem;
        z-index: 1000;
        .mobile {
          display: block;
          img {
            padding-top: 1.1rem;
            width: 3rem;
            // height: 100%;
          }
        }
      }
      cursor:pointer;
      &.right {
        right:0%;
        width:50%;
        @media #{$small-up} {
          cursor:url( '../../assets/right.svg' ), e-resize;
        }

      }
      &.left {
        left:0%;
        width:50%;
        @media #{$small-up} {
          cursor:url( '../../assets/left.svg' ), w-resize;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PageFlipper.vue